import React from 'react'
import PropTypes from 'prop-types'

const IconLabel = ({icon, label}) => {
  return (
    <div className="icon-label">
      {icon}
      <span>{label}</span>
    </div>
  )
}

IconLabel.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
}

export default IconLabel
